module.exports = __webpack_public_path__ + "static/media/leshan-logotu.8e12a669.png";